import React, { useCallback } from 'react';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import type { Vote } from '@atlassian/jira-issue-shared-types/src/common/types/issue-type.tsx';
import { useIntl } from '@atlassian/jira-intl';
import type { VoteServiceProps } from '../../common/types.tsx';
import { useVoteField } from '../../services/vote-field-service/index.tsx';
import messages from './messages.tsx';

const VoteToggleMeatballMenuItemCommon = ({
	value,
	toggleValue,
}: {
	value: Vote;
	toggleValue: (isDropdownItem: boolean) => void;
}) => {
	const { formatMessage } = useIntl();

	const handleClick = useCallback(() => {
		toggleValue(false);
	}, [toggleValue]);

	return (
		<DropdownItem key="vote" onClick={handleClick}>
			{value.hasVoted ? formatMessage(messages.removeVote) : formatMessage(messages.addVote)}
		</DropdownItem>
	);
};

const VoteToggleMeatballMenuItemRelay = ({
	onFieldUpdated,
	useVoteField: useVoteFieldFromProps,
}: VoteServiceProps) => {
	// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
	const [{ value }, { toggleValue }] = useVoteFieldFromProps({ onFieldUpdated });

	return <VoteToggleMeatballMenuItemCommon value={value} toggleValue={toggleValue} />;
};

const VoteToggleMeatballMenuItemRedux = ({ onFieldUpdated }: VoteServiceProps) => {
	const [{ value }, { toggleValue }] = useVoteField({ onFieldUpdated });

	return <VoteToggleMeatballMenuItemCommon value={value} toggleValue={toggleValue} />;
};

export const VoteToggleMeatballMenuItem = componentWithFG(
	'relay-migration-issue-header-and-parent',
	VoteToggleMeatballMenuItemRelay,
	VoteToggleMeatballMenuItemRedux,
);
